import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center","width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Color = _resolveComponent("Color")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Color, {
      block: "",
      name: "アウトライン(色)",
      "model-value": _ctx.modelValue,
      style: {"margin-right":"var(--spacingInlineSmall)"},
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, null, 8 /* PROPS */, ["model-value"]),
    _createVNode(_component_IconButton, {
      type: "danger",
      name: "アウトライン(削除)",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('remove')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Delete)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}